(function () {
  'use strict';

  function initProduct(root) {
    if (!root || root.dataset.plcInitialized === 'true') return;
    root.dataset.plcInitialized = 'true';

    var form = root.querySelector('[data-plc-product-form]');
    var sizeButtons = root.querySelectorAll('[data-plc-size]');
    var variantInput = root.querySelector('[data-plc-variant-id]');
    var price = root.querySelector('[data-plc-price]');
    var atc = root.querySelector('[data-plc-atc]');
    var sizeError = root.querySelector('[data-plc-size-error]');
    var confirm = root.querySelector('[data-plc-confirm]');
    var prelaunch = root.getAttribute('data-prelaunch') === 'true';
    var selectedVariantId = null;
    var requestPanel = root.querySelector('[data-plc-size-request]');
    var requestSize = root.querySelector('[data-plc-request-size]');
    var addLabel = atc ? atc.textContent.trim() : '';
    var submitting = false;

    function selectSizeButton(btn) {
      if (!btn || btn.disabled) return;
      sizeButtons.forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      var selectedPrice = btn.getAttribute('data-variant-price');
      if (price && selectedPrice) price.textContent = selectedPrice;
      var available = btn.getAttribute('data-available') !== 'false';
      if (!available) {
        selectedVariantId = null;
        if (variantInput) variantInput.value = '';
        if (atc) {
          atc.disabled = true;
          atc.setAttribute('aria-disabled', 'true');
          atc.textContent = root.dataset.soldOutLabel;
        }
        if (sizeError) sizeError.classList.remove('is-visible');
        if (requestPanel && requestSize) {
          var requestedId = btn.getAttribute('data-variant-id');
          Array.from(requestSize.options).forEach(function (option) {
            option.selected = option.dataset.variantId === requestedId;
          });
          requestPanel.open = true;
          requestSize.focus({ preventScroll: true });
          requestPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        return;
      }
      if (requestPanel) requestPanel.open = false;
      selectedVariantId = btn.getAttribute('data-variant-id');
      if (variantInput) variantInput.value = selectedVariantId || '';
      if (atc && !prelaunch) {
        atc.textContent = addLabel;
        atc.disabled = submitting;
        atc.removeAttribute('aria-disabled');
      }
      if (sizeError) sizeError.classList.remove('is-visible');
      var hint = root.querySelector('[data-plc-atc-hint]');
      if (hint) hint.style.display = selectedVariantId ? 'none' : '';
    }

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectSizeButton(btn);
      });
    });

    // Prefer first available size so Add to Cart is clearly usable
    if (!prelaunch) {
      var firstAvailable = null;
      sizeButtons.forEach(function (btn) {
        if (!firstAvailable && !btn.disabled && btn.getAttribute('data-available') !== 'false' && btn.getAttribute('data-variant-id')) {
          firstAvailable = btn;
        }
      });
      if (firstAvailable && sizeButtons.length === 1) {
        selectSizeButton(firstAvailable);
      }
    }

    root.querySelectorAll('[data-plc-acc-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.plc-product__acc');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    var guideOpen = root.querySelector('[data-plc-size-guide-open]');
    var guideModal = root.querySelector('[data-plc-size-guide]');
    var guideClose = root.querySelectorAll('[data-plc-size-guide-close]');
    if (guideOpen && guideModal) {
      guideOpen.addEventListener('click', function () {
        guideModal.hidden = false;
      });
      guideClose.forEach(function (el) {
        el.addEventListener('click', function () {
          guideModal.hidden = true;
        });
      });
    }

    var photoDialog = root.querySelector('[data-plc-gallery-dialog]');
    var photoImage = root.querySelector('[data-plc-gallery-image]');
    if (photoDialog && photoImage && typeof photoDialog.showModal === 'function') {
      var photoLinks = Array.from(root.querySelectorAll('[data-plc-gallery-open]'));
      var photoIndex = 0;
      var photoStage = photoDialog.querySelector('[data-plc-gallery-stage]');
      var photoControls = photoDialog.querySelector('[data-plc-gallery-controls]');
      var photoPrevious = photoDialog.querySelector('[data-plc-gallery-previous]');
      var photoNext = photoDialog.querySelector('[data-plc-gallery-next]');
      var swipeStart = null;

      function showPhoto(index) {
        if (!photoLinks.length) return;
        photoIndex = (index + photoLinks.length) % photoLinks.length;
        var link = photoLinks[photoIndex];
        var thumbnail = link.querySelector('img');
        photoImage.src = link.href;
        photoImage.alt = thumbnail ? thumbnail.alt : '';
      }

      if (photoControls) photoControls.hidden = photoLinks.length < 2;
      photoLinks.forEach(function (link, index) {
        link.addEventListener('click', function (event) {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          showPhoto(index);
          if (!photoDialog.open) photoDialog.showModal();
        });
      });
      if (photoPrevious) photoPrevious.addEventListener('click', function () { showPhoto(photoIndex - 1); });
      if (photoNext) photoNext.addEventListener('click', function () { showPhoto(photoIndex + 1); });
      photoDialog.addEventListener('keydown', function (event) {
        if (photoLinks.length < 2 || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          showPhoto(photoIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      if (photoStage) {
        photoStage.addEventListener('pointerdown', function (event) {
          if (event.pointerType !== 'touch') return;
          if (!event.isPrimary || photoLinks.length < 2) {
            swipeStart = null;
            return;
          }
          swipeStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
          photoStage.setPointerCapture(event.pointerId);
        });
        photoStage.addEventListener('pointerup', function (event) {
          if (!swipeStart || event.pointerId !== swipeStart.id) return;
          var deltaX = event.clientX - swipeStart.x;
          var deltaY = event.clientY - swipeStart.y;
          swipeStart = null;
          if (Math.abs(deltaX) >= 50 && Math.abs(deltaX) > Math.abs(deltaY) * 1.3) {
            showPhoto(photoIndex + (deltaX < 0 ? 1 : -1));
          }
        });
        photoStage.addEventListener('pointercancel', function () { swipeStart = null; });
        photoStage.addEventListener('lostpointercapture', function () { swipeStart = null; });
      }
      var photoClose = photoDialog.querySelector('[data-plc-gallery-close]');
      if (photoClose) photoClose.addEventListener('click', function () { photoDialog.close(); });
      photoDialog.addEventListener('close', function () { swipeStart = null; });
      photoDialog.addEventListener('click', function (event) {
        if (event.target !== photoDialog) return;
        var bounds = photoDialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
          photoDialog.close();
        }
      });
    }

    var track = root.querySelector('[data-plc-mobile-track]');
    var dots = root.querySelectorAll('[data-plc-dot]');
    if (track && dots.length) {
      track.addEventListener('scroll', function () {
        var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var slides = track.querySelectorAll('.plc-product__mobile-slide');
          if (!slides[i]) return;
          slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      });
    }

    if (!form || !atc) return;

    if (!prelaunch && selectedVariantId) {
      atc.disabled = false;
      atc.removeAttribute('aria-disabled');
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (prelaunch || submitting) return;

      if (!selectedVariantId) {
        if (sizeError) sizeError.classList.add('is-visible');
        return;
      }

      submitting = true;
      atc.disabled = true;
      var addUrl = '/cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: Number(selectedVariantId),
          quantity: 1
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          if (confirm) {
            confirm.classList.add('is-visible');
            confirm.textContent = 'Added to bag';
          }
          var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
          if (window.PLCSiteSound) window.PLCSiteSound.navigate(cartUrl);
          else window.location.href = cartUrl;
        })
        .catch(function () {
          if (confirm) {
            confirm.classList.add('is-visible');
            confirm.textContent = 'Could not add to bag. Try again.';
          }
        })
        .finally(function () {
          submitting = false;
          if (!prelaunch) {
            atc.disabled = !selectedVariantId;
            atc.setAttribute('aria-disabled', String(!selectedVariantId));
          }
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-plc-product]').forEach(initProduct);
  }

  document.addEventListener('plc:page-ready', boot);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
